import { patchStorage, getStorage } from '../local-storage';
const consumerIdValidator = require('../compiled-validators/validators').consumerId;
export async function ingestConsumerId(consumerId) {
    const isValid = consumerIdValidator(consumerId);
    if (!isValid) {
        console.error(`DI CCDP :: IngestConsumerId validation failure; ${JSON.stringify(consumerIdValidator.errors)}`);
        throw new Error('DI CCDP :: IngestConsumerId validation failure');
    }
    patchStorage({ consumerId });
}
export async function egressConsumerId() {
    const storage = getStorage();
    return storage.consumerId;
}
export async function removeConsumerId() {
    patchStorage({ consumerId: undefined });
}
